import React from "react";
import { CheckCircle2, Award } from "lucide-react";
import { company, featurePoints, values } from "../mock";
import { SectionLabel, CountUp, OrangeButton, Reveal } from "../components/common";

const About = () => {
  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="max-w-[1320px] mx-auto px-5 grid lg:grid-cols-2 gap-14 items-center">
        {/* Images */}
        <Reveal direction="left" className="relative">
          <img
            src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"
            alt="Salmons Brothers team working on site"
            className="rounded-lg w-full h-[420px] md:h-[520px] object-cover"
          />
          <div className="absolute -bottom-8 -right-4 md:right-8 bg-[#CD0008] text-white rounded-lg px-8 py-6 shadow-2xl">
            <div className="display-heading text-5xl">
              <CountUp end={company.yearsExperience} suffix="+" />
            </div>
            <p className="text-sm uppercase tracking-wide mt-1">Years of experience</p>
          </div>
          <div className="hidden md:flex absolute -top-6 -left-6 w-24 h-24 bg-[#0B102D] rounded-lg items-center justify-center text-[#CD0008]">
            <Award size={44} />
          </div>
        </Reveal>

        {/* Text */}
        <Reveal direction="right">
          <SectionLabel>About Our Company</SectionLabel>
          <h2 className="section-heading text-[#0B102D] text-4xl md:text-5xl mb-6">
            We build houses. You make it a home.
          </h2>
          <p className="text-gray-600 leading-relaxed mb-5">{company.about}</p>
          <p className="text-gray-600 leading-relaxed mb-8">{company.about2}</p>

          <div className="grid sm:grid-cols-2 gap-x-8 gap-y-4 mb-9">
            {values.map((v) => (
              <div key={v.title} className="flex gap-3">
                <CheckCircle2 className="text-[#CD0008] shrink-0 mt-0.5" size={22} />
                <div>
                  <h4 className="font-display font-bold text-[#0B102D]">{v.title}</h4>
                  <p className="text-sm text-gray-500">{v.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="flex flex-wrap items-center gap-8">
            <OrangeButton to="/about">About Our Company</OrangeButton>
            <ul className="space-y-1">
              {featurePoints.map((f) => (
                <li key={f} className="flex items-center gap-2 text-sm text-gray-700">
                  <CheckCircle2 size={16} className="text-[#CD0008]" /> {f}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default About;
